export default __webpack_public_path__ + "static/media/profile - 3066 Vishesh Garg.ba4d8efc.jpeg";